import { darken } from "@material-ui/core/styles/colorManipulator";
import { css, Theme } from "@emotion/react";

const BaseButton = (props: { theme: Theme }) => css`
    align-items: center;
    background: ${props.theme.palette.common.white};
    border: none;
    border-radius: 1px;
    box-sizing: border-box;
    color: ${props.theme.palette.common.black};
    cursor: pointer;
    display: flex;
    font-size: 16px;
    font-weight: bold;
    justify-content: center;
    letter-spacing: 1.5px;
    line-height: 1.5em;
    padding: 0.75em;
    position: relative;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    width: 100%;

    :hover {
        background: ${darken(props.theme.palette.common.white, 0.08)};
        transition: all 0.3s ease;
    }

    :active {
        background: ${darken(props.theme.palette.common.white, 0.25)};
    }

    :disabled {
        background: ${props.theme.palette.grey[20]};
        cursor: default;
    }

    ${props.theme.breakpoints.up("desktop")} {
        padding: 0.75em 2em;
    }
`;

export default BaseButton;
